// AuthnContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import {jwtDecode} from 'jwt-decode';

const AuthnContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Read token from localStorage and decode it on first render
  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log('Decoded token:', decoded);
        setUser(decoded);
        // Optional: check token expiry
        // if (decoded.exp * 1000 > Date.now()) {
        //   setUser(decoded);
        // } else {
        //   localStorage.removeItem('accessToken');
        // }
      } catch (err) {
        console.error('Invalid token:', err);
        localStorage.removeItem('accessToken');
      }
    }
  }, []);

  const login = (token, refreshToken) => {
    try {
      const decoded = jwtDecode(token);
      localStorage.setItem('accessToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      console.log('Decoded token:', decoded);
      setUser(decoded);
      localStorage.setItem('username', decoded.name);
    } catch (err) {
      console.error('Login failed: invalid token');
    }
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    setUser(null);
  };

  return (
    <AuthnContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthnContext.Provider>
  );
};

// Hook for easy access to auth context
export const useAuth = () => useContext(AuthnContext);
